<template>
    <form class="home" v-if="controlrecord.code==1">
      <label>Form auto open <input v-model="controlrecord.formOpen.DateTime" required type="datetime-local" name="formOpen" /></label>
      <label>Form auto close <input v-model="controlrecord.formClose.DateTime" required type="datetime-local" name="formClose" /></label>
      <label>Admin email <input placeholder="Enter administrator email"  v-model="controlrecord.adminEmail" required name="adminEmail" /></label>
      <label>Maximum Places <input placeholder="Enter maximum places available"  v-model="controlrecord.maxSubs" required name="maxSubs" /></label>
      <label>Banner text <textarea placeholder="Optional banner text"  v-model="controlrecord.bannerText" required name="bannerText"></textarea></label>
      <label>Post Submission Message <textarea placeholder="Message to display after form is posted"  v-model="controlrecord.submissionMessage" required name="submissionMessage"></textarea></label>
      <label>Intended Date Options* <textarea placeholder="Labels for form checkboxes"  v-model="controlrecord.intendedDates" required name="intendedDates"></textarea></label>
      <label>Previous Attempt Options* <textarea placeholder="Labels for form checkboxes"  v-model="controlrecord.previousAttempts" required name="previousAttempts"></textarea></label>
      <p class="info full-width">* Dates are seperated with a comma (no extra spaces) and must be entered as YYYY or MMM YYYY only. October 2019 is <strong>not</strong> valid. A few words can follow the year so long as it does not start with a month.</p>
      <hr/><label class="full-width"><button @click="ssoSubmit">Update</button></label>
    </form>
</template>

<script>
export default {
    props: ['controlrecord'],
    data: function () {
        return {
            submittedOk: false
        }
    },
    methods:{
        ssoSubmit: async function (ev) {
            ev.preventDefault();
            const fd = new FormData(document.querySelector("form"));
            let resp = await fetch(process.env.VUE_APP_ENDP1,{method:"POST", body:fd});
            let json = await resp.json();
            if (json.code==1){
                alert("Database updated");
                this.submittedOk = true ;
            }
        }
    }
}
</script>

<style>

</style>